const appConfig = {
  apiPrefix: "/api",
  authenticatedEntryPath: "/projects",
  unAuthenticatedEntryPath: "/sign-in",
  tourPath: "/app/account/kyc-form",
  enableMock: true,
};

export default appConfig;
